import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useCart } from "@/lib/cart";

const FORM_KEY = "ayur_checkout_form";

/**
 * One tap to buy a past order again: the cart is refilled at today's prices and the
 * checkout form is pre-filled with the address it went to last time. Items since
 * withdrawn or out of stock are named rather than quietly dropped, and nothing is
 * charged — the buyer still reviews the cart and pays.
 */
export const useReorder = (token = "") => {
  const { add } = useCart();
  const nav = useNavigate();
  const [busy, setBusy] = useState("");

  const reorder = async (orderId) => {
    setBusy(orderId);
    try {
      const { data } = await api.get(`/orders/${orderId}/reorder`, { params: token ? { token } : {} });
      if (data.items.length === 0) {
        toast.error("None of these items are available right now");
        return;
      }
      data.items.forEach((it) =>
        add({ id: it.id, name: it.name, price: it.price, image: it.image }, it.quantity)
      );

      try {
        const saved = JSON.parse(localStorage.getItem(FORM_KEY) || "{}");
        localStorage.setItem(FORM_KEY, JSON.stringify({
          ...saved,
          customer_name: data.customer_name || saved.customer_name || "",
          customer_phone: data.customer_phone || saved.customer_phone || "",
          customer_email: data.customer_email || saved.customer_email || "",
          address: data.address || saved.address || "",
        }));
      } catch (e) {
        console.error("reorder prefill failed:", e);
      }

      const skipped = data.unavailable.map((u) => `${u.name} (${u.reason})`).join(", ");
      toast.success(`${data.items.length} item(s) back in your cart`, {
        description: skipped ? `Not added: ${skipped}` : "Your last delivery address is filled in.",
      });
      nav("/checkout");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally { setBusy(""); }
  };

  return { reorder, busy };
};

export default useReorder;
